import { render, staticRenderFns } from "./ForeignInvestmentDetailsPage.vue?vue&type=template&id=0d949d83"
import script from "./ForeignInvestmentDetailsPage.vue?vue&type=script&lang=js"
export * from "./ForeignInvestmentDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports